<template>
    <div class="casedetails_box">
        <el-form label-position="top" label-width="80px" :model="form" ref="form" :rules="rules">
            <el-form-item label="案例名称" prop="name" :rules="[
					  { required: true, message: '请输入案例名称'},
					]">
                <el-input v-model="form.name" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="案例介绍" prop="intro" :rules="[
					  { required: true, message: '请输入案例介绍'},
					]">
                <el-input v-model="form.intro" maxlength="40"></el-input>
            </el-form-item>
            <el-form-item label="IOS下载地址">
                <el-input v-model="form.ios" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="安卓下载地址">
                <el-input v-model="form.android" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="安卓二维码" prop="android_url">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload" :before-upload="beforeUploadFile" :on-change="handleChange"
                    :file-list='fileList' :on-remove="handleRemove">
                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,建议大小:110x110</div>
                </el-upload>
                <div>
                    <img :src="form.android_url" class="img" v-if="form.android_url">
                </div>
            </el-form-item>
            <el-form-item label="IOS二维码" prop="ios_url">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload2" :before-upload="beforeUploadFile" :on-change="handleChange2"
                    :file-list='fileList2' :on-remove="handleRemove2">
                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,建议大小:110x110</div>
                </el-upload>
                <div>
                    <img :src="form.ios_url" class="img" v-if="form.ios_url">
                </div>
            </el-form-item>
            <el-form-item label="导览图（供主页显示" prop="name" :rules="[
					  { required: true, message: '请上传导览图'},
					]">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload3" :before-upload="beforeUploadFile" :on-change="handleChange3"
                    :file-list='fileList3' :on-remove="handleRemove3">
                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,建议大小:320x240</div>
                </el-upload>
                <div>
                    <img :src="form.navigation" class="img" v-if="form.navigation">

                </div>
            </el-form-item>
            <el-form-item label="案例图片1">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload4" :before-upload="beforeUploadFile" :on-change="handleChange4"
                    :file-list='fileList4' :on-remove="handleRemove4">
                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,建议大小:397x705</div>
                </el-upload>
                <div>
                    <img :src="form.one" class="img" v-if="form.one">

                </div>
            </el-form-item>
            <el-form-item label="案例图片2">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload5" :before-upload="beforeUploadFile" :on-change="handleChange5"
                    :file-list='fileList5' :on-remove="handleRemove5">
                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,建议大小:397x705</div>
                </el-upload>
                <div>
                    <img :src="form.two" class="img" v-if="form.two">

                </div>
            </el-form-item>
            <el-form-item label="案例图片3">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload6" :before-upload="beforeUploadFile" :on-change="handleChange6"
                    :file-list='fileList6' :on-remove="handleRemove6">

                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,建议大小:397x705</div>
                </el-upload>
                <div>
                    <img :src="form.three" class="img" v-if="form.three">

                </div>
            </el-form-item>
            <el-form-item label="案例图片4">
                <el-upload class="avatar-uploader" ref="upload" action="" :auto-upload="true" name="image7"
                    :http-request="upload7" :before-upload="beforeUploadFile" :on-change="handleChange7"
                    :file-list='fileList7' :on-remove="handleRemove7">
                    <el-button size="small">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">jpg格式,建议大小:397x705</div>
                </el-upload>
                <div>
                    <img :src="form.four" class="img" v-if="form.four">

                </div>
            </el-form-item>
            <el-button class="btn" type="primary" @click="Save">保存设置</el-button>
        </el-form>
    </div>
</template>

<script>
    import local from '../utils/local'
    import {
        instanceAdd
    } from '../api/api'
    import axios from "axios";

    export default {
        data() {
            var address = (rule, value, callback) => {
                if (!value.replace(/(^\s*)|(\s*$)/g, "")) {
                    return callback(new Error("请输入下载地址"));
                } else {
                    const reg = /[\u4E00-\u9FA5]/i;
                    if (!reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error("请输入正确的下载地址"));
                    }
                }
            };
            return {
                form: {
                    admin_id: local.get('admin_id'),
                    name: '',
                    ios: '',
                    intro: '',
                    android: '',
                    android_url: '',
                    ios_url: '',
                    navigation: "",
                    one: '',
                    two: '',
                    three: '',
                    four: ''
                },
                formData: new FormData(),
                fileList: [],
                fileList2: [],
                fileList3: [],
                fileList4: [],
                fileList5: [],
                fileList6: [],
                fileList7: [],

                rules: {
                    android: [{
                            required: true,
                            validator: address,
                            trigger: "blur"
                        } // 非空

                    ],
                    ios: [{
                            required: true,
                            validator: address,
                            trigger: "blur"
                        } // 非空

                    ]
                }

            }
        },
        methods: {

            beforeUploadFile(file) {
                const isJPG = file.type === "image/jpeg";
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error("上传图片只能是 JPG格式!");
                }
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过 2MB!");
                }
                return (isJPG && isLt2M);
            },

            upload(file) {
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('http://api1.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {
                        this.form.android_url = res.data.data.url;

                    }
                })

            },
            handleRemove(file, fileList) {
                this.fileList.shift()
                this.form.android_url = '';

            },
            upload2(file) {
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('http://api1.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {

                        this.form.ios_url = res.data.data.url;

                    }
                })

            },
            handleRemove2(file, fileList) {
                this.fileList2.shift()
                this.form.ios_url = '';

            },
            upload3(file) {
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('http://api1.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {
                        // this.formData.append("navigation", res.data.data.url);
                        this.form.navigation = res.data.data.url;

                    }
                })

            },
            handleRemove3(file, fileList) {
                this.fileList3.shift()
                this.form.navigation = '';

            },
            upload4(file) {
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('http://api1.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {
                        // this.formData.append("one", res.data.data.url);
                        this.form.one = res.data.data.url;

                    }
                })

            },
            handleRemove4(file, fileList) {
                this.fileList4.shift()
                this.form.one = '';

            },
            upload5(file, fileList) {
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('http://api1.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {
                        // this.formData.append("two", res.data.data.url);
                        this.form.two = res.data.data.url;

                    }
                })

            },
            handleRemove5(file, fileList) {
                this.fileList5.shift()
                this.form.two = '';

            },
            upload6(file, fileList) {
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('http://api1.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {
                        this.form.three = res.data.data.url;

                    }
                })

            },
            handleRemove6(file, fileList) {
                this.fileList6.shift()
                this.form.three = '';

            },
            handleChange(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },
            handleChange2(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList2 = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },
            handleChange3(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList3 = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },
            handleChange4(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList4 = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },
            handleChange5(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList5 = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },
            handleChange6(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList6 = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },
            handleChange7(file, fileList) {
                if (fileList.length > 0) {
                    this.fileList7 = [fileList[fileList.length - 1]]; // 这一步，是 展示最后一次选择的csv文件
                }

            },

            upload7(file) {
                console.log(file)
                var formD = new FormData();
                formD.append('file', file.file);
                axios.post('http://api1.home.didigo.es/admin/admin/photo', formD).then(res => {
                    if (res.data.status == 200) {

                        this.form.four = res.data.data.url;

                    }
                })
            },
            handleRemove7(file, fileList) {
                this.fileList7.shift()
                this.form.four = '';

            },

            Save() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (this.form.id) {
                            this.formData.append("admin_id", this.form.admin_id);
                            this.formData.append("id", this.form.id);
                            this.formData.append("name", this.form.name);
                            this.formData.append("ios", this.form.ios);
                            this.formData.append("android", this.form.android);
                            this.formData.append("intro", this.form.intro);
                            this.formData.append("android_url", this.form.android_url);
                            this.formData.append("ios_url", this.form.ios_url);
                            this.formData.append("navigation", this.form.navigation);
                            this.formData.append("one", this.form.one);
                            this.formData.append("two", this.form.two);
                            this.formData.append("three", this.form.three);
                            this.formData.append("four", this.form.four);
                            axios.post('http://api1.home.didigo.es/admin/admin/instanceEdit', this.formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data"
                                },

                            }).then(res => {
                                if (res.data.status == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功'
                                    })

                                    this.$router.push('/home/case')
                                } else {
                                    this.$message.error(res.data.msg)
                                }
                            })
                        } else {
                            this.formData.append("admin_id", this.form.admin_id);
                            this.formData.append("name", this.form.name);
                            this.formData.append("ios", this.form.ios);
                            this.formData.append("android", this.form.android);
                            this.formData.append("intro", this.form.intro);
                            this.formData.append("android_url", this.form.android_url);
                            this.formData.append("ios_url", this.form.ios_url);
                            this.formData.append("navigation", this.form.navigation);
                            this.formData.append("one", this.form.one);
                            this.formData.append("two", this.form.two);
                            this.formData.append("three", this.form.three);
                            this.formData.append("four", this.form.four);
                            axios.post('http://api1.home.didigo.es/admin/admin/instanceAdd', this.formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data"
                                },

                            }).then(res => {
                                if (res.data.status == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功'
                                    })

                                    this.$router.push('/home/case')
                                } else {
                                    this.$message.error(res.data.msg)
                                }
                            })
                        }
                    }
                })

            }
        },
        created() {
            if (this.$route.query.data) {
                let data = JSON.parse(this.$route.query.data);
                Object.assign(this.form, data);
                console.log(this.form)
            }
        }
    }
</script>

<style lang="less" scoped>
    .casedetails_box {
        padding: 0 50px;

        .el-form-item {
            // margin: 0;

            .el-form--label-top .el-form-item__label {
                padding: 0 !important;
            }

            .el-input {
                width: 800px;
            }

            .el-upload__tip {
                margin: 0;
            }

            .img {
                width: 110px;
            }

        }

        .btn {
            margin-top: 20px;
        }
    }
</style>